import type { DropdownProps } from "react-day-picker";
import { useDayPicker } from "react-day-picker";

import { Select } from "@/shared/ui/form";

export const MonthSelect = ({ value, options }: DropdownProps) => {
  const { months, goToMonth } = useDayPicker();

  return (
    <Select
      value={value as number}
      options={options}
      onChange={(month) => {
        const currentDate = months[0]?.date ?? new Date();
        currentDate.setMonth(month);
        goToMonth(currentDate);
      }}
    />
  );
};
